import { BuildingEnergyModelFragment } from '../../../generated/graphql'
import { i18n } from '../../../i18n'
import {
  averageByEvenNumberRange,
  averageByHour,
  dayHours,
  hoursOfTheDay,
  monthsSumSerie,
  rangeValues,
  yearMonths,
} from './calibration-util'
import {
  createChartSerie,
  createChartSerieValues,
  createDefaultLineChartSerie,
  CustomLineStyles,
  CustomSeries,
} from './chart-util'

const DEFAULT_VENTILATION_LINETYPE = CustomLineStyles.Solid
const DEFAULT_VENTILATION_LINEWIDTH = 0.1

export const calcVentilationHeatingByHourChartData = (
  model: BuildingEnergyModelFragment,
  cutSerie: number[],
  ventilationHeatingSerie: number[],
): CustomSeries => {
  const id = i18n.t(
    'buildingEnergyModels.calibration.dataTypes.ventilationHeating',
  )

  const hourValues = dayHours()

  const result = createDefaultLineChartSerie(
    id,
    hourValues,
    DEFAULT_VENTILATION_LINETYPE,
    DEFAULT_VENTILATION_LINEWIDTH,
    true,
  )

  const { area } = model

  const ventilationSerie = ventilationHeatingSerie.map((i) => i / area)

  const hours = hoursOfTheDay(0)

  const ventilationData = averageByHour(
    hourValues,
    ventilationSerie,
    cutSerie,
    hours,
  )

  result.data = createChartSerieValues(hourValues, ventilationData)

  return result
}

export const calcVentilationHeatingByEvenTempRangeChartData = (
  model: BuildingEnergyModelFragment,
  tempRangeStart: number,
  tempRangeEnd: number,
  tempRangeStep: number,
  outsideTempHourSerie: number[],
  cutSerie: number[],
  ventilationHeatingSerie: number[],
): CustomSeries => {
  const id = i18n.t(
    'buildingEnergyModels.calibration.dataTypes.ventilationHeating',
  )

  const temperatureValues = rangeValues(
    tempRangeStart,
    tempRangeEnd,
    tempRangeStep,
  )

  const result = createDefaultLineChartSerie(
    id,
    temperatureValues,
    DEFAULT_VENTILATION_LINETYPE,
    DEFAULT_VENTILATION_LINEWIDTH,
    true,
  )

  const { area } = model

  const ventilationSerie = ventilationHeatingSerie.map((i) => i / area)

  const ventilationData = averageByEvenNumberRange(
    temperatureValues,
    outsideTempHourSerie,
    ventilationSerie,
    cutSerie,
  )

  result.data = createChartSerieValues(temperatureValues, ventilationData)

  return result
}

export const calcSumVentilationHeatingByMonthChartData = (
  ventilationHeatingSerie: number[],
  year: number,
): CustomSeries => {
  const id = i18n.t(
    'buildingEnergyModels.calibration.dataTypes.ventilationHeating',
  )

  const monthValues = yearMonths()

  const ventilationData = monthsSumSerie(ventilationHeatingSerie, year)

  return createChartSerie(
    id,
    monthValues,
    ventilationData,
    DEFAULT_VENTILATION_LINETYPE,
    DEFAULT_VENTILATION_LINEWIDTH,
    true,
  )
}
